import type { Reducer } from 'redux';

export type ReducersMap = Record<string, Reducer<any, any>>;
export type ReducerChangeListener = (reducers: ReducersMap) => void;

class ReducerRegistry {
  private emitChange: ReducerChangeListener | null = null;
  private reducers: ReducersMap = {};

  getReducers(): ReducersMap {
    return { ...this.reducers };
  }

  register(name: string, reducer: Reducer<any, any>): void {
    this.reducers = { ...this.reducers, [name]: reducer };
    if (this.emitChange) {
      this.emitChange(this.getReducers());
    }
  }

  setChangeListener(listener: ReducerChangeListener): void {
    this.emitChange = listener;
  }
}

const reducerRegistry = new ReducerRegistry();
export default reducerRegistry;
